import {cn} from 'platform/shared-tw';

import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface EngineBlockProps {
  variant?: DiagramVariant;
  onClick?: () => void;
}

export function EngineBlock(props: EngineBlockProps) {
  return (
    <svg
      width="206"
      height="158"
      viewBox="0 0 206 158"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="absolute [pointer-events:none] cursor-pointer group"
      style={{top: 172, left: 113}}
      onClick={props.onClick}
    >
      <path
        d="M162 156.991C162.472 157.017 162.772 156.988 162.889 156.9C162.889 156.9 192 125.041 192 124.04V113H205V45H192V33.96C192 32.9591 162.889 1.09961 162.889 1.09961C162.772 1.01247 162.472 0.9844 162 1.00977V1C139 1 51.3704 2.1475 33 7C19.9479 10.4477 7.99581 25.6723 4 31C1 35 1 46.393 1 48V110C1 111.607 1 123 4 127C7.99581 132.328 19.9479 147.552 33 151C51.3704 155.853 139 157 162 157V156.991Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M192 113C131.34 113 28 102 28 102C10.2849 99.8911 6 90.0486 6 79C6 67.9514 10.2849 58.109 28 56C28 56 131.34 45 192 45"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path d="M28 9V38" stroke="currentColor" className={partStroke({variant: props.variant})} />
      <path
        d="M16 38C13.9349 37.3116 12.0403 36.6801 10 36"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M19 36C15.7624 34.9208 13.2104 34.0701 10 33"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M23 34C17.945 32.4446 14.8632 31.4964 10 30"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M24 31L12 27"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M25 28.0001C21.5363 26.961 18.751 26.1254 15 25.0001"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M17 22.0001C19.5676 22.7336 21.698 23.3423 24 24.0001"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M20 20.0001L24 21.0001"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M24 34.0001V17.0001C21 18.0001 12 27.0001 10 30.0001L10 43.0001C10 43.0001 15 38.0001 24 34.0001Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M192 124.041C192 125.041 162.889 156.9 162.889 156.9C160 159.072 42.5351 125.041 29.5712 120.658C1.36888 111.121 0.999996 94.7554 0.999997 79C0.999997 63.2446 1.36888 46.879 29.5712 37.3424C42.5351 32.9588 160 -1.07199 162.889 1.09954C162.889 1.09954 192 32.9586 192 33.9595L192 79L192 124.041Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M192 124C149.346 122.079 78.0306 114.08 34 109C8 106 0.999998 97 0.999998 79C0.999998 61 8 52 34 49C78.0307 43.9196 149.346 35.9215 192 34"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M1 79C1 79 1 62.1665 1 48C1 46.393 1 35 4 31C7.99581 25.6723 19.9479 10.4477 33 7C51.3704 2.1475 139 1 162 1"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M150 62L158 58"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M150 65.9999L158 61.9999"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M150 66L158 62"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M149 70.5L158 66"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M149 74.5L158 70"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M149 78.5L158 74"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M149 82.5L158 78"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M149 86.5L158 82"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M150 90L158 86"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M150 94L158 90"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M150 98L158 94"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M158 98L152 101"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M158 104L158 79L158 54"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M192 109C183 109 158 106 152 101C149.29 98.7414 149 88 149 79C149 70 149.29 59.2586 152 57C158 52 183 49 192 49"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M192 113H205V79V45H192"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M28 149V120"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M16 120C13.9349 120.688 12.0403 121.32 10 122"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M19 122C15.7624 123.079 13.2104 123.93 10 125"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M23 124C17.945 125.555 14.8632 126.504 10 128"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M24 127L12 131"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M25 130C21.5363 131.039 18.751 131.875 15 133"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M17 136C19.5676 135.266 21.698 134.658 24 134"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M20 138L24 137"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M24 124V141C21 140 12 131 10 128L10 115C10 115 15 120 24 124Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M162 157C139 157 51.3704 155.853 33 151C19.9479 147.552 7.99581 132.328 4 127C1 123 1 111.607 1 110C1 95.8335 1 79 1 79C1 79 1 62.1665 1 48C1 46.393 1 35 4 31C7.99581 25.6723 19.9479 10.4477 33 7C51.3704 2.1475 139 1 162 1"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M53.2803 120.262C56.1964 121.11 58.9987 120.292 59.5391 118.435C60.0792 116.577 58.1526 114.383 55.2363 113.535C52.3201 112.687 49.5177 113.506 48.9775 115.363C48.4378 117.221 50.3642 119.414 53.2803 120.262Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M54 148C58.4183 148 62 144.418 62 140C62 135.582 58.4183 132 54 132C49.5817 132 46 135.582 46 140C46 144.418 49.5817 148 54 148Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <ellipse
        cx="54.2584"
        cy="116.899"
        rx="5.49911"
        ry="3.50233"
        transform="rotate(16.215 54.2584 116.899)"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <circle
        cx="54"
        cy="140"
        r="4"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <circle
        cx="54"
        cy="140"
        r="8"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M54 132L54 117"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <circle
        cx="28"
        cy="79"
        r="12"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></circle>
      <path
        d="M28 69L28 89"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <circle
        cx="28"
        cy="79"
        r="12"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <circle
        cx="28"
        cy="78.8175"
        r="8"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
    </svg>
  );
}
